function preSelectStSwatches(){
  document.querySelectorAll('.product-card-wrapper').forEach(function (card) {
    const productJson = card.getAttribute('data-product');
    if (!productJson) return;

    let productData;
    try {
      productData = JSON.parse(productJson);
    } catch (e) {
      console.error('Invalid product JSON:', e);
      return;
    }
    const firstAvailableVariant = productData.variants.find(v => v.available) || productData.variants[0];
    let selectedSize = firstAvailableVariant?.option1;
    let selectedPotli = firstAvailableVariant?.option2 ?? null;
    let activeVariantId = firstAvailableVariant?.id ?? null;
    // let activeVariantId = productData.variants?.find(variant => variant.inventory_quantity > 0)?.id || productData.variants?.[0]?.id || null;
    const updateHref = () => {
       const links1 = card.querySelectorAll('.card__heading a');
       const links2 = card.querySelectorAll('.card__media');
       const links3 = card.querySelectorAll('.card__media a');
       if (links1 && activeVariantId) {
         links1.forEach(link=>{
           link.href = `/products/${productData.handle}?variant=${activeVariantId}`;
         })         
       }
       if (links2 && activeVariantId) {
         links2.forEach(link=>{
           link.href = `/products/${productData.handle}?variant=${activeVariantId}`;
         })         
       }
       if (links3 && activeVariantId) {
         links3.forEach(link=>{
           link.href = `/products/${productData.handle}?variant=${activeVariantId}`;
         })         
       }
    };

    card.querySelectorAll('[data-option-type="size"]').forEach(el => {
      const value = el.dataset.value;
      const variantForSize = productData.variants.find(v => v.option1 === value);
      if (!variantForSize || !variantForSize.available) {
        el.classList.add('disabled');
      } else {
        el.classList.remove('disabled');
      }
    });
    const updateSelection = () => {
      const match = productData.variants.find(v =>
        v.option1 === selectedSize &&
        (productData.options.length > 1 ? v.option2 === selectedPotli : true)
      );

      if (match) {
        activeVariantId = match.id;

        card.querySelectorAll('[data-option-type="size"]').forEach(el => {
          // el.classList.toggle('active', el.dataset.value === selectedSize)
          if (!el.classList.contains('disabled')) {
            el.classList.toggle('active', el.dataset.value === selectedSize);
          } else {
            el.classList.remove('active');
          }
        });

        card.querySelectorAll('[data-option-type="potli"]').forEach(el =>
          el.classList.toggle('active', el.dataset.value === selectedPotli)
        );
        updateHref();
      }
    };

    card.querySelectorAll('[data-option-type="size"]').forEach(sizeEl => {
      sizeEl.addEventListener('click', function () {
        selectedSize = this.dataset.value;
        updateSelection();
      });
    });

    card.querySelectorAll('[data-option-type="potli"]').forEach(potliEl => {
      potliEl.addEventListener('click', function () {
        selectedPotli = this.dataset.value;
        updateSelection();
      });
    });

    updateSelection();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  preSelectStSwatches();
});
